class BmProductForm extends HTMLElement {
  connectedCallback() {
    this.variants = JSON.parse(this.querySelector('[data-product-variants]')?.textContent || '[]');
    this.idInput = this.querySelector('[data-variant-id-input]');
    this.gallery = this.closest('.grid')?.querySelector('bm-product-gallery') || null;

    this.addEventListener('change', (event) => {
      if (event.target.matches('[data-option-position]')) this.updateVariant();
    });

    this.observeStickyBar();
  }

  updateUrl(variantId) {
    if (!variantId || !('history' in window)) return;

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.history.replaceState(window.history.state, '', url);
  }

  observeStickyBar() {
    const stickyBar = this.querySelector('[data-sticky-info-bar]');
    const mainButton = this.querySelector('[data-main-add-to-cart]');
    if (!stickyBar || !mainButton || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(([entry]) => {
      stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
    });
    observer.observe(mainButton);
  }

  updateVariant() {
    const selected = {};
    this.querySelectorAll('[data-option-position]:checked').forEach((input) => {
      selected[input.dataset.optionPosition] = input.value;
    });

    this.querySelectorAll('[data-selected-value]').forEach((el) => {
      const value = selected[el.dataset.selectedValue];
      if (value) el.textContent = value;
    });

    const variant = this.variants.find((variant) =>
      Object.entries(selected).every(([position, value]) => variant.options[Number(position) - 1] === value)
    );

    const addToCartButtons = this.querySelectorAll('[data-add-to-cart-button]');
    const priceEls = this.querySelectorAll('[data-product-price]');

    if (!variant) {
      if (this.idInput) this.idInput.value = '';
      addToCartButtons.forEach((button) => {
        button.disabled = true;
        button.textContent = button.dataset.unavailableLabel || 'Unavailable';
      });
      return;
    }

    if (this.idInput) this.idInput.value = variant.id;

    addToCartButtons.forEach((button) => {
      button.disabled = !variant.available;
      button.textContent = variant.available
        ? button.dataset.defaultLabel || 'Add to cart'
        : button.dataset.soldOutLabel || 'Sold out';
    });

    priceEls.forEach((el) => {
      el.textContent = variant.price;
    });

    if (this.gallery) this.gallery.setActiveMedia(variant.featuredMediaId);
    this.updateUrl(variant.id);
  }
}

customElements.define('bm-product-form', BmProductForm);
